import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_MOBILE_BROWSER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const cloudFullscreen: 'a' | 'b' | 'c' | 'd' | 'e' = getFeature('cloud-fullscreen');

export const cloudFullscreenB: boolean = cloudFullscreen === 'b';
export const cloudFullscreenC: boolean = cloudFullscreen === 'c';
export const cloudFullscreenD: boolean = cloudFullscreen === 'd';
export const cloudFullscreenE: boolean = cloudFullscreen === 'e';

export const enabledCloudFullscreen: boolean =
    !IS_BIZ_USER &&
    !IS_CORP_USER &&
    !IS_PAID_USER &&
    !IS_MOBILE_BROWSER &&
    (cloudFullscreenB || cloudFullscreenC || cloudFullscreenD || cloudFullscreenE);

export const fullscreenTariffId = getFeature('fullscreen-tariff-id') || '';

registerExperiment('fullscreen-mailspace', cloudFullscreen, [
    AnalyticEventNames.FULLSCREEN_SHOW,
    AnalyticEventNames.FULLSCREEN_CLICK,
    AnalyticEventNames.FULLSCREEN_CLICK_ALL,
    AnalyticEventNames.FULLSCREEN_CLOSE,
]);
